var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactsheetBrickCore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 25,
    viewBox: "0 0 224 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.93359H42.1808C43.9629 1.93359 45.6906 2.54805 47.0725 3.67338L69.4372 21.8853C70.8191 23.0106 72.5468 23.6251 74.329 23.6251H161.808C164.302 23.6251 166.643 22.4247 168.098 20.3999L179.054 5.15877C180.51 3.13396 182.851 1.93359 185.345 1.93359H223.113",
    stroke: "#979797",
    strokeWidth: 2.32409
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactsheetBrickCore);
export default __webpack_public_path__ + "static/media/factsheetBrickCore.994c51bd28b45a95e9dcf2044e9b8ed7.svg";
export { ForwardRef as ReactComponent };